import { styled } from '@mui/material';

import { Box, Modal, Typography } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';

import { NewPluginVersionModalImage } from '../NewPluginVersionModalImage';

const StyledDescription = styled(Box)({
  textAlign: 'left',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  marginBottom: theme.spacing(2),
}));

const StyledText = styled(Typography)({
  color: 'var(--text-text-secondary-color)',
});

const ImageContainer = styled('div')({
  svg: {
    maxWidth: '100%',
  },
});

export const NewPluginVersionModalContent = () => {
  const { t } = useI18n();

  const getTitle = () => {
    switch (import.meta.env.VITE_ENV) {
      case 'prod':
        return t('config:new_plugin_version_title');
      default:
        return t('config:new_dev_plugin_version_title');
    }
  };

  const getDescription = () => {
    switch (import.meta.env.VITE_ENV) {
      case 'prod':
        return t('config:new_plugin_version_text');
      default:
        return t('config:new_dev_plugin_version_text');
    }
  };

  return (
    <Modal data-testid="new-plugin-version-modal">
      <Modal.Content>
        {import.meta.env.VITE_ENV === 'prod' ? (
          <ImageContainer>
            <NewPluginVersionModalImage />
          </ImageContainer>
        ) : null}
        <StyledDescription>
          <StyledTitle variant="header" component="h2">
            {getTitle()}
          </StyledTitle>
          <StyledText variant="body2">{getDescription()}</StyledText>
        </StyledDescription>
        {import.meta.env.VITE_ENV !== 'prod' ? (
          <ImageContainer>
            <NewPluginVersionModalImage />
          </ImageContainer>
        ) : null}
      </Modal.Content>
    </Modal>
  );
};
